module.exports = require("tesseract.js");